import { DesignClass, ObjectClass } from "@app/types";

export default class LocalVariablesUsedIn {

    static getVariablesUsedInMap(localVariables, module, serialized) {
        const variablesUsedInMap = {};


        localVariables.forEach(v => {
            const variableUsedIn = LocalVariablesUsedIn.getVariableUsedIn(v, module, serialized);
            variablesUsedInMap[v.id] = variablesUsedInMap[v.id] || [];
            variablesUsedInMap[v.id].push(variableUsedIn);
        });
        return variablesUsedInMap;
    }

    // validation: unused
    static getUnusedVariables(localVariables, module, serialized) {
        const variablesUsedInMap = LocalVariablesUsedIn.getVariablesUsedInMap(localVariables, module, serialized);
        const unusedVariables = [];

        Object.entries(variablesUsedInMap).forEach(ent => {
            if (ent[1][0].length === 0) {
                unusedVariables.push(ent[0]);
            }
        });

        return unusedVariables;
    }


    // UsedIn popup
    static getVariableUsedIn(v, module, serialized) {
        const vName = 'mod.' + v.name;
        const usedInVariables = [];
        const { components, globalIntents } = serialized;

        // look in modules
        components.modules.forEach(mod => {
            const nodes = mod.versions[1].flow.nodes.filter(node => node._class === DesignClass.module || node._class === ObjectClass.data);
           
            nodes.forEach(node => {
                node.props.config['inputs'] = node.props.config['inputs'] || [];
                node.props.config['outputs'] = node.props.config['outputs'] || [];

                let variableIsFound = node.props.config['inputs'].concat(node.props.config['outputs']).findIndex(i => i.varName === vName) !== - 1

                if (variableIsFound) {
                    usedInVariables.push({
                        mod: mod,
                        node: node,
                        type: 'inFlowNode'
                    });
                }

                // Search specifically on Data Access Nodes
                if (node._class === ObjectClass.data) {
                    const httpRequestTimeoutVal = node.props.config.httpRequestTimeout || null;
                    variableIsFound = httpRequestTimeoutVal.toString() === vName;
                }

                if (node.props.parentComponentID === module.id) {
                    node.props.config['inputs'] = node.props.config['inputs'] || [];
                    node.props.config['outputs'] = node.props.config['outputs'] || [];

                    let variableIsFound = node.props.config['inputs'].findIndex(i => i.argumentName === vName) !== -1

                    if (variableIsFound) {
                        usedInVariables.push({
                            mod: mod,
                            node: node,
                            type: 'inFlowNode'
                        });
                    }
                }
            });
        });

            module.versions[1].flow.links.forEach(link => {
                // can links also have missing inputs?
                link.props.config.inputs = link.props.config.inputs || [];
                let variableIsFound = link.props.config.inputs.findIndex(i => i.varName === vName) !== - 1;

                if (variableIsFound) {
                    usedInVariables.push({
                        mod: module,
                        link: link,
                        type: 'inFlowLink'
                    });
                }
            });
        

            module.versions[1].flow.nodes.forEach(node => {

                const inputs = node.props.config['inputs'] || [];
                const outputs = node.props.config['outputs'] || [];
                const promptText = (node.props.config.text && node.props.config.text['en-US']) ? node.props.config.text['en-US'] : null;
                const scriptText = (node.props.config.function && node.props.config.function['script']) ? node.props.config.function['script'] : null;
                const funcArgs = (node.props.config.function && node.props.config.function['arguments']) ? node.props.config.function['arguments'] : null;
                const scriptProgress = node.props.config.scriptProgress || null;
                const transferReason = node.props.config.transferReason || null;
                const transferDestination = node.props.config.transferDestination || null;
                const billing = node.props.config.billing || null;
                const customTag = node.props.config.customTag && node.props.config.customTag['value'] || null;
                const promptReference = node.props.config.promptReference || null;
                const moduleReference = node.props.config.moduleReference || null;
                const analystClass = node.props.config.analystClass || null;
                const externalAudioUrlVarName = node.props.config.externalAudioUrlVarName || null;
                const exitComponentCustomHeaders = node.props.config.exitComponent && node.props.config.exitComponent.customHeaders || [];
                const exitComponentDestination = node.props.config.exitComponent && node.props.config.exitComponent.destination || null;
                const customHttpHeaders = node.props.config['headers'] || [];
                const sessionNodeDestination = node.props.config['destination'] || null;
                const httpRequestTimeout = node.props.config.httpRequestTimeout || null;
                const isVariableFound = [...inputs, ...outputs, ...customHttpHeaders].findIndex(i => i.varName === vName) !== -1
                    || promptText && promptText.indexOf(vName) !== -1
                    || funcArgs && funcArgs.findIndex(args => args.varName === vName) !== -1
                    || scriptProgress && scriptProgress.indexOf(vName) !== -1
                    || transferReason && transferReason.indexOf(vName) !== -1
                    || transferDestination && transferDestination.indexOf(vName) !== -1
                    || customTag && customTag.indexOf(vName) !== -1
                    || billing && billing['value'] && billing['value'].indexOf(vName) !== -1
                    || promptReference && promptReference.indexOf(vName) !== -1
                    || moduleReference && moduleReference.indexOf(vName) !== -1
                    || analystClass && analystClass.indexOf(vName) !== -1
                    || exitComponentCustomHeaders && exitComponentCustomHeaders.findIndex(ch => ch['value'].indexOf(vName) !== -1) !== -1
                    || exitComponentDestination && exitComponentDestination === v.id
                    || externalAudioUrlVarName && externalAudioUrlVarName === vName
                    || sessionNodeDestination && sessionNodeDestination === vName
                    || httpRequestTimeout && httpRequestTimeout.toString() === vName;

                if (isVariableFound) {
                    const obj = window.apm.serialized.components.objects.find(o => o.id === node.props.parentComponentID);
                    if (obj) {
                        usedInVariables.push({
                            obj,
                            type: 'inApplicationObjectConfig'
                        });
                    }
                }


            });
 
   
            globalIntents.forEach(gi => {
                if (gi.module && gi.moduleProperties.props.config.inputs && gi.moduleProperties.props.config.inputs.length > 0) {
                    if (gi.moduleProperties.props.config.inputs.findIndex(input => input.argumentName === vName) !== -1) {
                        usedInVariables.push({
                            gi,
                            type: 'inGlobalIntent'
                        });
                    }
                }
                if (gi.intent && gi.conditionProperties.props.config.inputs && gi.conditionProperties.props.config.inputs.length > 0) {
                    if (gi.conditionProperties.props.config.inputs.findIndex(input => input.argumentName === vName) !== -1) {
                        usedInVariables.push({
                            gi,
                            type: 'inGlobalIntent'
                        });
                    }
                }
            });

        // globalIntents module inputs

        return usedInVariables;
    }
}